<template>
  <div class="main-box">
    <div>
      <mainHander></mainHander>
    </div>
    <div class="content">
      <div class="leftRail">
        <mainLeftRail></mainLeftRail>
      </div>
      <div class="page-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import mainHander from './header/mainHander.vue'
import mainLeftRail from './leftRail/mainLeftRail.vue'
export default {
  name: 'HeaderLeftRail',
  components: {
    mainHander,
    mainLeftRail,
  },
  data() {
    return {}
  },
}
</script>

<style lang="less" scoped>
.main-box {
  width: 100vw;
  height: 100vh;
  background-color: #edeff1;

  .content {
    display: flex;
    margin-top: 1rem;
    .leftRail {
      width: 16rem;
      height: calc(100vh - 80px);
      background: #ffffff;
    }
    .page-content {
      width: 100%;
      flex-grow: 1;
      flex-shrink: 1;
      margin-left: 1rem;
      height: calc(100vh - 80px);
      overflow: scroll;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
}
</style>
